/** Shared empty sentinel so null/undefined/[] rebinds do not look like a new value. */
export const EMPTY_ARRAY: never[] = Object.freeze([]) as unknown as never[];

/** Lit `hasChanged` for array props: same ref or both empty → no update. */
export function arrayPropHasChanged(value: unknown, old: unknown): boolean {
  const next = Array.isArray(value) ? value : EMPTY_ARRAY;
  const prev = Array.isArray(old) ? old : EMPTY_ARRAY;
  if (next === prev) return false;
  if (next.length === 0 && prev.length === 0) return false;
  return true;
}

/** Coerce null/undefined/empty to the shared empty sentinel. */
export function coerceArray<T>(value: T[] | null | undefined): T[] {
  return Array.isArray(value) && value.length > 0
    ? value
    : (EMPTY_ARRAY as unknown as T[]);
}
